export const moduleLabels = {
    'new-incident': 'Incident',
    avc: 'Advanced Threat Control',
    av: 'Antivirus',
    registration: 'Productregistratie',
    modules: 'Security modules',
    install: 'Installatie',
    uninstall: 'De-installatie',
    'hwid-change': 'Hardware ID wijziging',
    'endpoint-moved-out': 'Endpoint verplaatst',
    'task-status': 'Taakstatus',
    aph: 'Antiphishing',
    uc: 'User Control',
    fw: 'Firewall',
};

export const statusLabels = {
    active: 'Actief',
    closed: 'Gesloten',
    paused: 'Gepauzeerd',

    avc_disinfected: 'Gedetecteerd en opgeschoond',
    aph_blocked: 'Geblokkeerd door antiphishing',
    uc_site_blocked: 'Website geblokkeerd',
    portscan_blocked: 'Poortscan geblokkeerd',

    registered: 'Geregistreerd',
    'still present': 'Nog aanwezig',
};

export const fieldLabels = {
    product_installed: 'Geïnstalleerd product',
    companyId: 'Company ID',
    computer_name: 'Computer',
    computer_fqdn: 'FQDN',
    computer_ip: 'IP-adres',
    computer_id: 'Computer ID',
    endpointId: 'Endpoint ID',
    hwid: 'Hardware ID',
    old_hwid: 'Oude hardware ID',
    new_hwid: 'Nieuwe hardware ID',
    userId: 'Gebruiker ID',
    taskId: 'Taak ID',
    taskName: 'Taaknaam',
    taskType: 'Taaktype',
    targetName: 'Doel',
    isSuccessful: 'Succesvol',
    status: 'Status',
    errorMessage: 'Foutmelding',
    errorCode: 'Foutcode',
    reason: 'Reden',
    protocol_id: 'Protocol',
    source_ip: 'Bron IP',
    last_blocked: 'Laatst geblokkeerd',
    count: 'Aantal',
    url: 'URL',
    block_type: 'Blokkadetype',
    categories: 'Categorieën',
};

export const translateModule = (value) => {
    return moduleLabels[value] || value || 'Onbekend';
};

export const translateStatus = (value) => {
    if (value === null || value === undefined || value === '') {
        return '';
    }

    const stringValue = String(value);

    return statusLabels[stringValue] || stringValue.replaceAll('_', ' ');
};

export const translateProtocol = (value) => {
    const id = String(value);

    if (id === '6') {
        return 'TCP';
    }

    if (id === '17') {
        return 'UDP';
    }

    if (id === '1') {
        return 'ICMP';
    }

    return value || '-';
};

export const translateBoolean = (value) => {
    return Number(value) === 1 || value === true ? 'Ja' : 'Nee';
};

export const getBooleanBadge = (value) => {
    return Number(value) === 1 || value === true ? 'success' : 'secondary';
};

export const translateTaskStatus = (value) => {
    const map = {
        1: 'Aangemaakt',
        2: 'Wordt uitgevoerd',
        3: 'Voltooid',
        4: 'Mislukt',
        5: 'Geannuleerd',
    };

    return map[Number(value)] || `Status ${value}`;
};

export const translateUninstallReason = (value) => {
    const map = {
        1: 'Handmatig verwijderd',
        2: 'Verwijderd van endpoint',
        3: 'Verwijderd door taak',
    };

    return map[Number(value)] || `Reden ${value}`;
};
